import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g transform="translate(4)">
      <path
        d="M4.5,15 C2.567,15 1,13.433 1,11.5 C1,10.235 1.676,9.09 2.75,8.468 L3,8.324 L3,2.5 C3,1.671 3.671,1 4.5,1 C5.152,1 5.701,1.419 5.908,2 L4.5,2 L4.5,3 L6,3 L6,4 L4.5,4 L4.5,5 L6,5 L6,6 L4.5,6 L4.5,7 L6,7 L6,8.324 L6.25,8.468 C7.324,9.09 8,10.235 8,11.5 C8,13.433 6.433,15 4.5,15 M7,7.758 L7,2.5 C7,1.119 5.881,0 4.5,0 C3.119,0 2,1.119 2,2.5 L2,7.758 C0.765,8.583 0,9.976 0,11.5 C0,13.985 2.015,16 4.5,16 C6.985,16 9,13.985 9,11.5 C9,9.976 8.235,8.583 7,7.758"/>
      <path d="M4.5,9 C5.881,9 7,10.119 7,11.5 C7,12.881 5.881,14 4.5,14 C3.119,14 2,12.881 2,11.5 C2,10.119 3.119,9 4.5,9"/>
    </g>
  </svg>
);
